import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { buildJbpPlanActionUrl } from 'partner360/lib/jbpPlanActionFlow'

import { PlanReviewSection } from '../model/types'

interface IBuildPlanReviewSectionUrlParams {
  section: PlanReviewSection
  partnerId: string
  fYear: number
  programType: ProgramTypes
}

const isFinancialSection = (section: PlanReviewSection) =>
  section === PlanReviewSection.FinancialGrowth ||
  section === PlanReviewSection.SobGrowth ||
  section === PlanReviewSection.PlanningMeasure

export const buildPlanReviewSectionUrl = ({
  section,
  partnerId,
  fYear,
  programType,
}: IBuildPlanReviewSectionUrlParams) => {
  if (isFinancialSection(section)) {
    return buildJbpPlanActionUrl({
      partnerId,
      fyear: fYear,
      offering: programType,
      includePlanningSection: false,
    })
  }

  return `/page/jbl-hpscoutso/pid/${encodeURIComponent(
    partnerId
  )}/fyear/${fYear}/ptype/${encodeURIComponent(programType)}/jbp-tab/21/pact/quality`
}
